(function () {
    $(document).ready(function () {

        if ($('.cat-element-button-block').length) {
            var $cat_element_button_block = $('.cat-element-button-block');
            var $fixedBtnBuyBlock = $('.fixedBtnBuyBlock');
            var $body = $("body");

            function fixedBtnBlock(extraTop) {
                var $scrollTop = $(window).scrollTop();

                if (($scrollTop + extraTop) > $cat_element_button_block.offset().top) {
                    $body.delay(800).addClass("fixed-btn-buy");
                    $fixedBtnBuyBlock.delay(800).addClass("active");
                } else {
                    $fixedBtnBuyBlock.delay(800).removeClass("active");
                    $body.delay(800).removeClass("fixed-btn-buy");
                }
            }

            if ($(window).width() > 992) {
                $(window).scroll(function () {
                    fixedBtnBlock(70);
                });
            } else {
                $(window).scroll(function () {
                    fixedBtnBlock(0);
                });
            }
        }
    });
})();
